import { ActivityType } from '../../../../../../pure-js/enums/ActivityType'
import { SprintActivity } from '../../../../../../pure-js/types/Sprint'

export interface ActivityWithSprint extends SprintActivity {
  sprintTitle: string
  sprintId: string
  participants: Array<{
    userId?: string
    name: string
    email?: string
    teamId?: string
  }>
  teamIds: string[]
}

/**
 * Get activity type display name
 */
export const getActivityTypeName = (type: ActivityType, t: (key: string, defaultValue?: string) => string): string => {
  const translationMap: Record<ActivityType, { key: string; fallback: string }> = {
    [ActivityType.INTRODUCTION]: { key: 'introduction', fallback: 'Introduction' },
    [ActivityType.FIRST_GAME]: { key: 'first_game', fallback: 'First Game' },
    [ActivityType.SHORT_GAME]: { key: 'short_game', fallback: 'Short Game' },
    [ActivityType.LONG_GAME]: { key: 'long_game', fallback: 'Long Game' },
    [ActivityType.SHORT_REFLECTION]: { key: 'short_reflection', fallback: 'AI Coached Debrief' },
    [ActivityType.LONG_REFLECTION]: { key: 'long_reflection', fallback: 'Group Reflection' }
  }

  const mapping = translationMap[type]

  if (!mapping) {
    return type
  }

  return t(`facilitator.sessions.activityTypeLabels.${mapping.key}`, mapping.fallback)
}

/**
 * Determine if activity is the first gaming session
 */
export const isFirstGamingSession = (activity: ActivityWithSprint): boolean => {
  return activity.type === ActivityType.FIRST_GAME
}

/**
 * Format time string from start and end dates
 */
export const formatActivityTime = (startDate: Date, endDate: Date): string => {
  return `${startDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  })} - ${endDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  })}`
}

/**
 * Get participants to display based on limit
 */
export const getParticipantsToDisplay = <T>(participants: T[], showAll: boolean, limit: number = 4): T[] => {
  return showAll ? participants : participants.slice(0, limit)
}

/**
 * Calculate remaining participants count
 */
export const getRemainingCount = (total: number, limit: number = 4): number => {
  return Math.max(0, total - limit)
}
